import React, { useEffect, useState } from 'react';
import { Tag as AntdTag, Tooltip } from 'antd';
import history from '../../redux/history';
import styles from './tag.module.sass';
import cx from 'classnames';
import { Link } from 'react-router-dom';
import { updateTag } from '../../redux/actions';
import { useDispatch } from 'react-redux';
import {
  clearFilterProfile,
  closeFilterSidebar,
} from '../../redux/actions/filters';

const Tag = (props) => {
  let {
    canClick = false,
    canRemove = true,
    onClose,
    tag,
    isTagManuallyCreated,
    tagColor,
    extraParams,
    showTooltip,
    tooltipText,
    filterProfileToBeCleared = false,
  } = props;

  const [color, setColor] = useState(null);
  const dispatch = useDispatch();

  const returnTagLink = () => {
    if (!canClick) return;

    return (
      '/' +
      window.location.search +
      (window.location.search?.includes('?') ? '&' : '?') +
      `tag=${tag?.name ?? tag?.tag}${extraParams ?? ''}`
    );
  };

  const handleTagClick = () => {
    if (!canClick) return;

    if (tag && (tag?.tag || tag?.name)) {
      if (filterProfileToBeCleared === true) {
        dispatch(clearFilterProfile());
        dispatch(closeFilterSidebar());
      }
      dispatch(updateTag(tag?.tag ?? tag?.name));

      history.push(
        `/${
          window.location.search +
            (window.location.search?.includes('?') ? '&' : '?') +
            'tag=' +
            tag?.tag ?? tag?.name
        }${extraParams ?? ''}`,
      );
    }
  };

  useEffect(() => {
    if (tagColor === 'gold') {
      setColor(styles.gold);
    } else if (tagColor === 'volcano') {
      setColor(styles.volcano);
    }
  }, [tagColor]);

  if (tag) {
    return (
      <Tooltip title={showTooltip ? tooltipText : ''}>
        <Link to={returnTagLink()}>
          <AntdTag
            onClick={() => handleTagClick()}
            closable={canRemove}
            onClose={onClose}
            className={cx(
              isTagManuallyCreated ? styles.manually_tag : styles.tag,
              color ? color : null,
            )}
          >
            <span>{tag.name ?? tag.tag}</span>
          </AntdTag>
        </Link>
      </Tooltip>
    );
  } else {
    return null;
  }
};

export default Tag;
